import React, {useEffect, useRef, useState} from 'react';
import ReactDOM from 'react-dom';
import './styles.css';
import {emojiCategories} from '../../../utils/Emojis';

export const EmojiPicker = ({anchorRef, onSelect, onClose}) => {
    const pickerRef = useRef();
    const [position, setPosition] = useState({top: 0, left: 0});
    const [activeTab, setActiveTab] = useState(Object.keys(emojiCategories)[0]);

    useEffect(() => {
        if (anchorRef.current) {
            const rect = anchorRef.current.getBoundingClientRect();
            const pickerHeight = 330;
            const pickerWidth = 560;

            const top = rect.top - pickerHeight - 8;
            const left = rect.left + rect.width / 2 - pickerWidth / 2;

            setPosition({top, left});
        }
    }, [anchorRef]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                pickerRef.current &&
                !pickerRef.current.contains(e.target) &&
                !anchorRef.current.contains(e.target)
            ) {
                onClose();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [onClose, anchorRef]);

    const picker = (
        <div
            className="emoji-picker"
            ref={pickerRef}
            style={{
                position: 'absolute',
                top: `${position.top}px`,
                left: `${position.left}px`,
            }}
        >
            <div className="emoji-tabs">
                {Object.keys(emojiCategories).map((icon) => (
                    <span
                        key={icon}
                        className={`emoji-tab ${activeTab === icon ? 'active' : ''}`}
                        onClick={() => setActiveTab(icon)}
                    >
            {icon}
          </span>
                ))}
            </div>
            <div className="emoji-grid">
                {emojiCategories[activeTab].map((emoji, index) => (
                    <span
                        key={index}
                        className="emoji-item"
                        onClick={() => onSelect(emoji)}
                    >
            {emoji}
          </span>
                ))}
            </div>
        </div>
    );

    return ReactDOM.createPortal(picker, document.body);
};



// WEBPACK FOOTER //
// ./src/components-new/general/EmojiPicker/index.jsx